import React from "react";

import { MentionsInput, Mention } from "react-mentions";
import { CustomComponentProps } from "utils/types/generalTypes";

export type MentionInputProps = CustomComponentProps & {
    val: string;
    // setVal: React.Dispatch<React.SetStateAction<string>>;
    setVal: (val: string) => void;
    placeholder?: string;
};

const MentionInput = ({
    val,
    setVal,
    placeholder = "Write something",
    className,
    style
}: MentionInputProps) => {
    const users = [
        {
            id: "walter",
            display: "@Walter White"
        },
        {
            id: "pipilu",
            display: "@皮皮鲁"
        },
        {
            id: "luxixi",
            display: "@鲁西西"
        },
        {
            id: "satoshi1",
            display: "@中本聪"
        },
        {
            id: "satoshi2",
            display: "@サトシ・ナカモト"
        },
        {
            id: "nobi",
            display: "@野比のび太"
        },
        {
            id: "sung",
            display: "@성덕선"
        },
        {
            id: "jesse",
            display: "@Jesse Pinkman"
        },
        {
            id: "gus",
            display: 'Gustavo "Gus" Fring'
        },
        {
            id: "saul",
            display: "@Saul Goodman"
        },
        {
            id: "hank",
            display: "@Hank Schrader"
        },
        {
            id: "skyler",
            display: "@Skyler White"
        },
        {
            id: "mike",
            display: "@Mike Ehrmantraut"
        },
        {
            id: "lydia",
            display: "@Lydìã Rôdarté-Qüayle"
        }
    ];
    const requestTag = [
        {
            id: "news",
            display: "#News"
        },
        {
            id: "sports",
            display: "#sports"
        },
        {
            id: "Middle-east",
            display: "#Middle-east"
        },
        {
            id: "gaza",
            display: "#Gaza"
        },
        {
            id: "food",
            display: "#Food"
        }
    ];
    return (
        <div className={`custom-mention-input ${className}`} style={style}>
            <MentionsInput
                value={val}
                onChange={(e) => setVal(e.target.value)}
                placeholder={placeholder}
            >
                <Mention trigger="@" data={users} />
                <Mention trigger="#" data={requestTag} />
            </MentionsInput>
        </div>
    );
};

export default MentionInput;
